/**------------------------------------------------------
 * TM Listing check API constants
 */
export enum EnumTmListingCheckError {
	InvalidTextError = 'invalid_text_error'
}
